module.exports = __webpack_public_path__ + "static/media/strip-owl-palm.4b1d4809.svg";